import React from 'react'
import { Button } from '@lmc/ui-kit'
import _ from 'lodash'
import { REPORTING_IDS } from '../../../../../common/constants'
import { useTranslation } from 'react-i18next'

const amountLookup = _.keyBy(REPORTING_IDS, 'value')
const styles = {
  container: { paddingTop: 12 },
  link: { fontSize: 14 },
}

export const LogMeasurements = ({ log, item, onClick, renderLink }) => {
  const { t } = useTranslation()

  if (log.emarRound) return null
  const keyOne = amountLookup[item.amountOneKey]
  const keyTwo = amountLookup[item.amountTwoKey]

  const chartId =
    keyOne?.chart || keyOne?.value || item?.amountOneKey || keyTwo?.chart

  const url = log.emarResidentMedication
    ? `/residents/${log.resident}/emar/${log.emarResidentMedication}/chart`
    : `/residents/${log.resident}/charts/${chartId}`

  if (renderLink) {
    return (
      <Button
        variant="text"
        style={styles.link}
        onClick={() => onClick(url)}
      >
        {log.emarResidentMedication
          ? t('components.logEditForm.viewMedication')
          : t('components.logEditForm.viewChart')}
      </Button>
    )
  }

  return (
    <div style={styles.container}>
      {keyOne && _.isNumber(log.amount1) && (
        <div>
          <strong>{keyOne.label}: </strong>
          {(keyOne.options &&
            _.find(keyOne.options, { value: log.amount1 })?.label) ||
            log.amount1}
        </div>
      )}
      {keyTwo && _.isNumber(log.amount2) && (
        <div>
          <strong>{keyTwo.label}: </strong>
          {(keyTwo.options &&
            _.find(keyTwo.options, { value: log.amount2 })?.label) ||
            log.amount2}
        </div>
      )}
      <Button
        variant="text"
        style={styles.link}
        onClick={() => onClick(url)}
      >
        {log.emarResidentMedication
          ? t('components.logEditForm.viewMedication')
          : t('components.logEditForm.viewChart')}
      </Button>
    </div>
  )
}

export default LogMeasurements
